import {Component, OnInit} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {RouterLink} from "@angular/router";
import {NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";


@Component({
    selector: 'app-admin-topbar',
    templateUrl: './admin-topbar.component.html',
    imports: [
    RouterLink,
    NgbTooltip,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem,
    FaIconComponent
],
    styleUrls: ['./admin-topbar.component.css']
})
export class AdminTopbarComponent implements OnInit {
  name: string;

  constructor(public keycloakService: KeycloakService) {
  }

  ngOnInit(): void {
    this.keycloakService.loadUserProfile().then((profile) => {
      if (profile.firstName && profile.lastName) {
        this.name = profile.firstName + ' ' + profile.lastName;
      } else {
        this.name = profile.username;
      }
    });
  }

  logout(): void {
    this.keycloakService.logout();
  }

}
